export default "__VITE_ASSET__6d2ece0d__"